import React from 'react'
import { jt, t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'
import { Detail } from 'components/shared/Detail/Detail'

import { useDeleteJobsModalState } from './hooks'

import styles from './DeleteJobsModal.module.scss'

export const DeleteJobsModal = ({ onCancel, onClose, onConfirm, isOpen }) => {
  const { state } = useDeleteJobsModalState()

  const { count, jobs, pks } = state

  const message =
    pks.length > 0 ? (
      <Detail className={styles.detail} key="jobs">
        <Detail.Content
          chips={jobs.map(({ name }) => name)}
          type="chipsGroup"
        />
      </Detail>
    ) : null

  return (
    <DeleteResourceModal
      alert={jt`You are deleting ${count} jobs listed below: ${message}`}
      className={styles.modal}
      message={t`Are you sure you want to delete?`}
      title={t`Delete jobs`}
      {...{ onCancel, onClose, onConfirm, isOpen }}
    />
  )
}
